import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import { FluentProvider, webLightTheme, Theme } from "@fluentui/react-components";

/* global document, Office, module, require, HTMLElement */

const customTheme: Theme = {
  ...webLightTheme,
  fontFamilyBase: "Poppins, sans-serif",
  colorBrandBackground: "#5171E6",
  colorBrandBackgroundHover: "#3F5BBF",
  colorBrandBackgroundPressed: "#2F4AA1",
};

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

/* Render application after Office initializes */
Office.onReady(() => {
  root?.render(
    <FluentProvider theme={customTheme}>
      <App />
    </FluentProvider>
  );
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root?.render(NextApp);
  });
}
